export const tokenScope = effectScope();

export const useAuthToken = createGlobalState(() => {
    const authToken = useStorage('authToken', ref(''), localStorage, {
        deep: true,
        writeDefaults: true,
        listenToStorageChanges: true,
    });

    const brand = useStorage('brand', ref(''), localStorage, {
        deep: true,
        writeDefaults: true,
        listenToStorageChanges: true,
    });

    const infoHomeMsg = useStorage('infoHomeMsg', ref<any>([]), localStorage, {
        deep: true,
        writeDefaults: true,
        listenToStorageChanges: true,
    });

    const sysKey = useStorage('sysKey', ref<string>(''), localStorage, {
        deep: true,
        writeDefaults: true,
        listenToStorageChanges: true,
    });

    return {
        authToken,
        brand,
        infoHomeMsg,
        sysKey,
    };
});

export const initToken = () => {
    tokenScope.run(() => {
        const { authToken } = useAuthToken();

        console.log('initToken：', authToken.value);
    });
};
